// Severity labels shown on screen. Kept in their own module so the page doesn't pull in
// the rules engine just to label findings.

export const SEVERITY_LABELS = {
  breach: 'Action needed',
  risk: 'Check this',
  info: 'For information',
} as const;
